import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="footer">
      <div className="top">
        <div>
          <span className="material-icons">call</span>
          <span>+39 3270896963</span>
        </div>
        <div>
          <span className="material-icons">house</span>
          <span>Rome Italy</span>
        </div>
        <div>
          <span className="material-icons">mail</span>
          <span>asyncusIt@gmail.com</span>
        </div>
      </div>
      <div className="bottom">
        <div className="terms">
          <span className="mr1 termsSpan">Copyright © 2020 Asyncus.</span>
          <Link to="/terms">
            <span>Terms & Conditions</span>
          </Link>
          <Link to="/privacy">
            <span>Privacy Policy</span>
          </Link>
        </div>
        <div className="social">
          <a
            href="https://www.facebook.com/Asyncus-105133427861394/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img src={require("../Assets/facebook.svg")} alt="facebook" />
          </a>
          <a
            href="https://www.youtube.com/channel/UC1Rt-5J-aSVayks5Ktmp1Gg"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img src={require("../Assets/youtube.svg")} alt="youtube" />
          </a>
          <a href="/" rel="noopener noreferrer" target="_blank">
            <img src={require("../Assets/twitter.svg")} alt="twitter" />
          </a>
          <a
            href="https://www.instagram.com/ahcodedesign/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img src={require("../Assets/instagram.svg")} alt="instagram" />
          </a>
        </div>
      </div>
    </div>
  );
}
